import { capfirst, intcomma } from 'journalize';
import cx from 'classnames';
import { Component, h } from 'preact';
import { PreactHTMLConverter } from 'preact-html-converter';
const BROADCAST_HEADER_IMG = `${process.env.PUBLIC_PATH}assets/images/TT-2020Elections_logo-embed.png`;
import OtherCandidate from './OtherCandidate';

// internal
import {
  sort_candidates_by_party,
  get_directory_slug,
} from '../election-utils';
import { showCountdown, source } from '../endpoints';
import formatPercent from '../utils/format-percent';
import sumValues from '../utils/sum-values';

// text
import text from '../../../data/text.json';

const converter = PreactHTMLConverter();

type Props = {
  contest: { [key: string]: any },
  flags: { [key: string]: any },
  annotations: { [key: string]: any },
  columnCount: number,
  contestTitle: string,
  asOf: string,
  includeCountyRundown?: boolean,
  isShowcaseRace?: boolean,
  isHomepage?: boolean,
  tableHeader: JSX.Element,
  renderCandidate: any,
  visibleCandidatesCount?: number,
  embedType: string,
  broadcastHeaderImage: string,
  activeContestId: string,
};

class Contest extends Component<Props> {
  constructor() {
    super();

    this.state = {
      viewAllCandidates: false,
    };
    this.onViewableToggle = this.onViewableToggle.bind(this);
  }

  onViewableToggle() {
    this.setState(prevState => ({
      viewAllCandidates: !prevState.viewAllCandidates, // set viewAllCandidates to what is wasn't before
    }));
  }
  render() {
    const {
      contest,
      flags,
      annotations,
      columnCount,
      contestTitle,
      isShowcaseRace,
      asOf,
      includeCountyRundown,
      renderCandidate,
      visibleCandidatesCount,
      isHomepage,
      tableHeader,
      embedType,
      broadcastHeaderImage,
      activeContestId,
    } = this.props;

    const { viewAllCandidates } = this.state;

    let totalVotes;
    let candidates;
    let winner_found;
    let pct_votes;
    let pct_votes_turnout;


    const shouldDisplayResult = contest.contest_result !== 'not called';

    const IsFlagged = flags && flags.length > 0 ? true : false;

    const IsRepTarget = IsFlagged && flags[0].value.rep_target ? true : false;

    const IsDemTarget = IsFlagged && flags[0].value.dem_target ? true : false;

    const hasTurnoutmodel =
      contest.office == 'U.S. House' ||
      contest.office == 'President' ||
      contest.office == 'U.S. Senate' ||
      contest.office == 'Texas Railroad Commission' ||
      contest.office == 'Texas Supreme Court' ||
      contest.office == 'Texas Court of Criminal Appeals'
        ? true
        : false;

    // const hasManualoverride =
    // (contest.office == 'U.S. House' && contest.office_division == 4) || (contest.office == 'U.S. House' && contest.office_division == 23) ? true : false;
    
    const hasManualoverride = false;


    const IsAnnotations =
      annotations && annotations.length > 0 && annotations[0].value != ''
        ? true
        : false;

    // The Republic API slugs don't match the directory url slugs so we need to get them

    let directory_slug;

    if (contest) {
      directory_slug = get_directory_slug(contest.office);
      totalVotes = sumValues(contest.candidacies, 'votes');
      candidates =
        totalVotes == 0
          ? sort_candidates_by_party(contest.candidacies)
          : contest.candidacies;
      winner_found = candidates
        .filter(item => item.is_winner === true)
        .map(item => item.name);
      pct_votes = formatPercent(
        totalVotes,
        contest.estimated_votes_high
        )
    
      pct_votes_turnout = pct_votes < 100 ? `An estimated ${pct_votes}% of votes have already been counted, according to Decision Desk HQ turnout models.` : `An estimated >99% of votes have already been counted, according to Decision Desk HQ turnout models.`
    }
    // Uncomment this and put it back to line 334 to put back the polling locations numbers
    

    const checkmark = '\u2713';

    let embedTypeUsable = 'none';

    if (typeof embedType !== 'undefined') {
      embedTypeUsable = embedType;
    }

    // set the class on the disclaimer, changes between partner embed and the default index page
    const isPartner =
      embedTypeUsable && embedTypeUsable == 'partner' ? true : false;

    const rowClass = cx({
      seat__races: !isShowcaseRace,
      seat__races__partner: isPartner,
      seat__highlight_races: isShowcaseRace,
    });

    const disclaimerClass = cx(
      'disclaimer-race',
      {
        'disclaimer-partner': isPartner,
        'disclaimer-homepage': isHomepage,
      } // disclaimer-partner needs to be after disclaimer-race
    );

    const contestMetricsClass = cx(
      'contest__metrics',
      {
        homepage__metrics: isHomepage,
        'non-homepage__metrics': !isHomepage,
      } // disclaimer-partner needs to be after disclaimer-race
    );

    const precinctsClass = cx('contest__precincts', {
      tribcast: embedType == 'tribcast',
      turnout_model_district: hasTurnoutmodel,
    });

    const countdownClass = cx('countdown', {
      tribcast: embedType == 'tribcast',
    });

    return (
      <div class="seat t-sans">
        {embedTypeUsable.includes('broadcast') && (
          <header class="embed-logo-container">
            <a
              href="https://www.texastribune.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="embed-logo"
                src={broadcastHeaderImage}
                alt="Texas 2020 November Election Results presented by The Texas Tribune"
              />
            </a>
          </header>
        )}
        {/* {IsFlagged == true && (
          <div class="seat__flag">
            <p class="office__flag">
              <span class="gold-star">★</span>Race to watch
            </p>
          </div>
        )} */}

        <div class={rowClass}>
          <div class="seat__race">
            <div class="race">
              <h3 class="seat__title">
                {!isHomepage && <span>{contestTitle}</span>}

                {directory_slug[0] != null && (
                  <a
                    href={`https://www.texastribune.org/directory/districts/${directory_slug[0]['directory-slug']}/${contest['office_division']}`}
                  >
                    <span
                      class="icon-div"
                      title="Click to learn more about this district"
                    >
                      <svg class="icon icon-info">
                        <use xlinkHref="#icon-info"></use>
                      </svg>
                    </span>
                  </a>
                )}
              </h3>

              {(IsAnnotations == true ||
                IsFlagged == true ||
                (shouldDisplayResult && source == 'Decision Desk HQ')) && (
                <div class={disclaimerClass}>
                  {source == 'Decision Desk HQ' && shouldDisplayResult && (
                    <div class="anno-text ddhq_winner">
                      <span class="dd_winner">{checkmark}</span>
                      <p class="annotations winner-call">
                        Decision Desk HQ has declared {winner_found} the winner{contest.office == 'President' && (<span> in Texas</span>)}.
                      </p>
                    </div>
                  )}

                  {IsAnnotations == true && (
                    <div class="anno-text notes">
                      <span class="is-sr-only">Note:</span>
                      <svg class="icon note-icon anno-div" aria-hidden="true">
                        <use xlinkHref="#note-icon" />
                      </svg>

                      <p class="annotations">
                        <span class="font-weight-bold">Noteworthy: </span>
                        {converter.convert(annotations[0].value)}
                      </p>
                    </div>
                  )}

                  {IsFlagged == true && flags[0].value.prose != '' && (
                    <div class="anno-text race_to_watch_note get__flag">
                      <span class="gold-star">★</span>
                      <p class="annotations">
                        <span class="font-weight-bold">Race to watch: </span>
                        {converter.convert(flags[0].value.prose)}
                      </p>
                    </div>
                  )}
                </div>
              )}
              <table class="race__candidates">
                {tableHeader}
                <tbody>
                  {isShowcaseRace &&
                    candidates.map((candidate: any, idx: any) =>
                      renderCandidate(candidate, idx, viewAllCandidates, {
                        totalVotes,
                      })
                    )}

                  {!isShowcaseRace &&
                    candidates.map((candidate: any, idx: any) =>
                      renderCandidate(candidate, idx, viewAllCandidates, {
                        totalVotes,
                      })
                    )}

                  {isHomepage && candidates.length > visibleCandidatesCount && (
                    <OtherCandidate
                      isViewable={!viewAllCandidates}
                      candidateCount={candidates.length}
                      embedType={embedType}
                      onClick={() => {
                        this.onViewableToggle();
                      }}
                    />
                  )}
                </tbody>

                {isHomepage &&
                  candidates.length > visibleCandidatesCount &&
                  viewAllCandidates && (
                    <tr class="candidate race__candidate-row">
                      <td
                        class="candidate__cell candidate__party t-align-center"
                        onClick={() => {
                          this.onViewableToggle();
                        }}
                      >
                        <svg class="icon icon-angle-up">
                          <use xlinkHref="#icon-angle-up" />
                        </svg>
                      </td>
                      <th class="candidate__cell candidate__name">
                        <button
                          class={embedType}
                          onClick={() => {
                            this.onViewableToggle();
                          }}
                        >
                          Show fewer ({visibleCandidatesCount})
                        </button>
                      </th>
                      <th class="candidate__cell candidate__votes"> </th>
                      <th class="candidate__cell candidate__pct"></th>
                    </tr>
                  )}
              </table>

              <div>
                <div class={contestMetricsClass}>
                {hasManualoverride == false && (
                  <p class={precinctsClass}>
                    {hasTurnoutmodel == false || source != 'Decision Desk HQ'
                      ? `${intcomma(
                        contest.pollinglocationsreporting
                      )} of ${intcomma(
                        contest.total_pollinglocations
                      )} polling locations reporting (${contest.pollinglocations_reporting_percent.toFixed(
                        1
                      )}%)`
                      : pct_votes_turnout}

                    <span class="source">{` Source: ${source}`}</span>
                  </p>)}
                  {hasManualoverride == true && (
                  <p class={precinctsClass}>
                    <span class="source">{` Source: Texas Secretary of State`}</span>
                  </p>)}
                </div>
              </div>
              {showCountdown == true && hasManualoverride == false && (
                <div class={countdownClass}>
                  <span class="counter">Last updated {asOf}</span>
                </div>
              )}
              {isHomepage && (
                <div class="homepage-link__full_results">
                  <a href="https://apps.texastribune.org/features/2020/general-election-results/">
                    View Full Results
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  isShowcaseRace: false,
  includeCountyRundown: false,
  visibleCandidatesCount: 2,
};

export default Contest;
